// extracted by mini-css-extract-plugin
export default {"table":"styles_table__CmeaE","dragging":"styles_dragging__JXvUi","headingRow":"styles_heading-row__mXLVW","draggingOver":"styles_dragging-over__W8cf6"};